import { getEmpPunchReport } from 'services/axios/punchingReport'

export const actions = {
  GET_EMP_PUNCH_REPORT: 'GET_EMP_PUNCH_REPORT',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const fetchEmpPunchReport = (
  month,
  year,
  selectedEmployeeId,
  skip = 0,
  limit = 10,
  locationId,
) => {
  return async (dispatch) => {
    const response = await getEmpPunchReport(
      month,
      year,
      selectedEmployeeId,
      skip,
      limit,
      locationId,
    )

    dispatch({
      type: actions.GET_EMP_PUNCH_REPORT,
      payload: {
        empPunchReport: response?.data || [],
        totalCount: response?.totalCount || response?.count || 0,
      },
    })
  }
}
